import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { WorkerDashboard } from './WorkerDashboard';
import { MaintenanceManagement } from '../maintenance/MaintenanceManagement';
import { QualityControlManagement } from '../quality-control/QualityControlManagement';
import { ProductionLineManagement } from '../production/ProductionLineManagement';
import { ProductionOperationsHub } from '../production/ProductionOperationsHub';
import { WorkOrderDetail } from '../production/WorkOrderDetail';
import { MachineFloor } from '../production/MachineFloor';
import { ProductionQueue } from '../production/ProductionQueue';
import { ReportGenerator } from '../reports/ReportGenerator';
import { ProductDisplayWrapper } from '../products/ProductDisplayWrapper';
import { ProductManagement } from '../products/ProductManagement';
import { useRbac } from '../../context/RbacContext';

const WorkerRoutes: React.FC = () => {
  const { hasPermission } = useRbac();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Routes>
        {/* Dashboard */}
        <Route 
          path="dashboard" 
          element={<WorkerDashboard />}
        />
        
        {/* Production Tasks */}
        <Route 
          path="production/operations" 
          element={<ProductionOperationsHub />}
        />

        <Route 
          path="production/work-orders/:id" 
          element={<WorkOrderDetail />}
        />

        <Route 
          path="production/machines" 
          element={<MachineFloor />}
        />

        <Route 
          path="production/queue" 
          element={<ProductionQueue />}
        />
        
        {/* Maintenance Tasks */}
        <Route 
          path="maintenance" 
          element={<MaintenanceManagement />}
        />
        
        {/* Quality Checks */}
        <Route 
          path="quality" 
          element={<QualityControlManagement />}
        />
        
        {/* Products */}
        <Route 
          path="products" 
          element={<ProductManagement />}
        />
        
        {/* Product Display (for viewing product details) */}
        <Route 
          path="products/display/:productId" 
          element={<ProductDisplayWrapper />}
        />
        
        {/* Reports */}
        <Route 
          path="reports" 
          element={<ReportGenerator />}
        />
        
        {/* Default route */}
        <Route 
          path="/" 
          element={<Navigate to="dashboard" replace />}
        />
        
        {/* Fallback route */}
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </Box>
  );
};

export default WorkerRoutes; 